import { render, staticRenderFns } from "./Generic.vue?vue&type=template&id=781f8336&scoped=true&"
import script from "./Generic.vue?vue&type=script&lang=js&"
export * from "./Generic.vue?vue&type=script&lang=js&"
import style0 from "./Generic.vue?vue&type=style&index=0&id=781f8336&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781f8336",
  null
  
)

export default component.exports